import { Component, warn, _decorator } from 'cc';
import LocalizedLabel from '../../../../../common/scripts/Toolkit/Components/LocalizedComponent/LocalizedLabel';
import Page from '../../../../../common/scripts/Toolkit/Components/Page/Page';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('NotificationPopup')
@requireComponent(Page)
export default class NotificationPopup extends Component {
    @property
    public readonly defaultStayDuration: number = 3000;

    @property(LocalizedLabel)
    private readonly contentLabel: LocalizedLabel = null;

    private _page: Page = null;
    private _showID: number = 0;

    private get page() {
        if (!this._page) {
            this._page = this.getComponent(Page);
        }
        return this._page;
    }

    public show(contentKey: string, closeAfterMs?: number, closeWhen?: Promise<any>): void {
        const showID = ++this._showID;
        this.contentLabel.key = contentKey;
        this.page.open(true);
        const hide = () => {
            if (this._showID !== showID) {
                return;
            }
            this.page.close();
        };
        closeAfterMs ??= this.defaultStayDuration;
        if (closeAfterMs <= 0) {
            warn(`Invalid closeAfterMs: ${closeAfterMs}, use default value instead`);
            closeAfterMs = this.defaultStayDuration;
        }
        this.scheduleOnce(hide, closeAfterMs / 1000);
        closeWhen?.then(hide);
    }
}
